var _defs, _rect, _use, _use2, _use3, _use4, _use5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9S(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "card",
    face: "9S",
    height: "3.5in",
    preserveAspectRatio: "none",
    viewBox: "-120 -168 240 336",
    width: "2.5in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "SS9",
    viewBox: "-600 -600 1200 1200",
    preserveAspectRatio: "xMinYMid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -500C350 -250 460 -100 460 100C460 300 260 340 210 340C110 340 55 285 100 300L130 500L-130 500L-100 300C-55 285 -110 340 -210 340C-260 340 -460 300 -460 100C-460 -100 -350 -250 0 -500Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 335,
    x: -119.5,
    y: -167.5,
    rx: 12,
    ry: 12,
    fill: "white",
    stroke: "black"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: -97.501,
    y: -145.501
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: 27.501,
    y: -145.501
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: -97.501,
    y: -71.833
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: 27.501,
    y: -71.833
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: -35,
    y: -35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: -97.501,
    y: -145.501
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: 27.501,
    y: -145.501
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: -97.501,
    y: -71.833
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SS9",
    height: 70,
    width: 70,
    x: 27.501,
    y: -71.833
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9S);
export default __webpack_public_path__ + "static/media/9S.5d867c45a8f068a06b80c0cd475a76ff.svg";
export { ForwardRef as ReactComponent };